const state = {
    showVerticalMenu: false,
    menuRoutes: '',
}

const mutations = {
    SET_MENU_ROUTES(state, menuRoutes) {
        state.menuRoutes = menuRoutes
    },

    SHOW_VERTICAL_MENU(state) {
        state.showVerticalMenu = true
    },

    HIDE_VERTICAL_MENU(state) {
        state.showVerticalMenu = false
    },
}

const actions = {
    async getRoutes({ commit }) {
        try {
            const response = await axios.get('/dashboard/routes')
            commit('SET_MENU_ROUTES', response.data)
        } catch (error) {
            // console.log(error)
            console.error('menuRoutes not loaded')
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
